import { Loader } from "./laya/net/Loader";
import { ClassUtils } from "./laya/utils/ClassUtils";
function dummy() { }
export function regClass(assetId) {
    return function (constructor) {
        ClassUtils.regClass(assetId, constructor);
    };
}
export function classInfo(info) { return dummy; }
export function runInEditor(constructor) { }
export function allowMultiple(constructor) {
    constructor.prototype._$singleton = false;
}
export function property(info) { return dummy; }
export function regLoader(fileExtensions, type, hotReloadable) {
    return function (constructor) {
        Loader.registerLoader(fileExtensions, constructor, type, hotReloadable);
    };
}
